import { makeAutoObservable, runInAction } from 'mobx';

import { UnitTypes } from '../utils/product';
import { PriceType, Product, ProductType, VatTypes } from '../model/Product';
import { Money } from '../utils/currency';
import { Currency } from '../constants/currency';

class EditProductStore {
  productId: string | null = null;

  unitType: string = UnitTypes.APIECE.id;

  title = '';

  tax = VatTypes.TWENTYFIVE;

  price = new Money(0, Currency.SEK);

  priceType: string = PriceType.STATIC;

  type: string = ProductType.PRODUCT;

  showDecimals = false;

  category = '';

  ean = {
    code: '',
    type: '',
    decimals: '',
  };

  showInShop = true;

  isLoading = false;

  constructor() {
    makeAutoObservable(this);
    this.reset();
  }

  reset() {
    runInAction(() => {
      this.productId = null;
      this.unitType = UnitTypes.APIECE.id;
      this.title = '';
      this.tax = VatTypes.TWENTYFIVE;
      this.price = new Money(0, Currency.SEK);
      this.priceType = PriceType.STATIC;
      this.type = ProductType.PRODUCT;
      this.showDecimals = false;
      this.category = '';
      this.showInShop = true;
      this.ean = {
        code: '',
        type: '',
        decimals: '',
      };
    });
  }

  get isNewProduct() {
    return !this.productId;
  }

  setUnitType(unitType: string) {
    this.unitType = unitType;
  }

  setTitle(title: string) {
    this.title = title;
  }

  setTax(tax: number) {
    this.tax = tax;
  }

  setPrice(price: number) {
    this.price = new Money(Math.round(price * 100), this.price.currency || Currency.SEK);
  }

  setPriceType(priceType: string) {
    this.priceType = priceType;
  }

  setType(type: string) {
    this.type = type;
  }

  setShowDecimals(showDecimals: boolean) {
    this.showDecimals = showDecimals;
  }

  setShowInShop(showInShop: boolean) {
    this.showInShop = showInShop;
  }

  setEanCode(newEanCode: string) {
    this.ean.code = newEanCode;
  }

  setEditProduct(product: Product | null) {
    if (product) {
      runInAction(() => {
        this.productId = product.id;
        this.title = product.title;
        this.price = new Money(product.price, Currency.SEK);
        this.tax = product.tax || product.tax === 0 ? product.tax : VatTypes.TWENTYFIVE;
        this.priceType = product?.priceType ? product.priceType : PriceType.STATIC;
        this.unitType = product.unitType;
        this.type = product.type ? product.type : ProductType.PRODUCT;
        this.showDecimals = product.showDecimals ? product.showDecimals : false;
        this.category = product.category ? product.category : '';
        this.showInShop = product.showInShop ?? true;
        this.ean = product?.ean ?? {
          code: '',
          type: '',
          decimals: '',
        };
      });
    } else {
      this.reset();
    }
    this.isLoading = true;
  }
}

export default EditProductStore;
